import React, { memo } from "react";

import LayoutHeader from "../LayoutHeader/LayoutHeader";
import VersionDisplay from "../VersionDisplay/VersionDisplay";
import ViewPort from "../elements/ViewPort/ViewPort";
import "./Layout.scss";
import "./Layout_kokoro.scss";
import "./Layout_shabuDays.scss";
import "./Layout_torikizoku.scss";

interface ILayout {
	children?: React.ReactNode;
}

const Layout: React.FC<ILayout> = ({ children }) => {
	return (
		<ViewPort container className="LayoutWrapper" direction="column" data-testid="HomePageCntr">
			<LayoutHeader data-testid="LayoutHeader" />
			<div className="LayoutContent">{children}</div>
			<VersionDisplay />
		</ViewPort>
	);
};

export default memo(Layout);
